"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./color-picker.component"));
__export(require("./color-picker.directive"));
__export(require("./color-picker.module"));
__export(require("./color-picker.service"));
__export(require("./formats"));
__export(require("./helpers"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-color-picker/dist/lib/index.js
// module id = ./node_modules/ngx-color-picker/dist/lib/index.js
// module chunks = 3